import axios from "axios"; // 引入axios模块
import { Message } from 'element-ui';
// 环境的切换
if (process.env.NODE_ENV == "development") {
    axios.defaults.withCredentials=true; 
    axios.defaults.baseURL = "http://localhost:8080";
} else if (process.env.NODE_ENV == "debug") {
    axios.defaults.withCredentials=true; 
    axios.defaults.baseURL = "http://localhost:8080";
    axios.defaults.baseURL = "";
} else if (process.env.NODE_ENV == "production") {
    axios.defaults.withCredentials=true; 
     //axios.defaults.baseURL = "http://teststaff.risfond.com/operationalData";//测试环境
    //   axios.defaults.baseURL = "http://staff.risfond.com/operationalData";//生产环境
        axios.defaults.baseURL = "https://staff.risfond.com/operationalData";//线上环境
}

// let Config = {
//   TIMEOUT: 20000,//设置超时时间为2秒
// }
// axios.defaults.timeout = Config.TIMEOUT;

axios.interceptors.request.use(config => {
    // let expires = window.localStorage.getItem('expires')
    // let nowTime = new Date().getTime();
    // if (nowTime > expires) {

    //   window.localStorage.removeItem('token')
    //   window.localStorage.removeItem('expires')
    //   window.localStorage.removeItem('userInfo')
    // }
    // const token = window.localStorage.getItem('token')

    //请求头中需要带有token【获取用户信息】
    // if (localStorage.getItem('TOKEN')) {
    //     config.headers.token = localStorage.getItem('TOKEN');
    // }
    // if (token) {
    //   config.headers.Authorization = "Bearer " + JSON.parse(token)
    // }
    return config

}, error => {
    if (error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
        console.log('请求超时，请稍后再试')
        return Promise.reject(error);          // reject这个错误信息
    }
    return Promise.reject(error)
})
// 响应拦截器
axios.interceptors.response.use(
    (response) => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            if (response.status === 403) {
                store.dispatch('Logout')
                Message({
                    message: 'token失效请重新登录',
                    type: 'warning'
                });
            } else {
                return Promise.reject(response);
            }
            return Promise.reject(response);
        }
    },
    (error) => {
        if (error.response.status) {
            return Promise.reject(error.response);
        }
    }
);

// get 方法
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params,
            })
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            });
    });
}

// post 方法
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            });
    });
}



// WEBPACK FOOTER //
// ./src/utils/request.js